export function isNumber(value) {
    var coercedValue = Number(value.toString());
    return !isNaN(coercedValue) && typeof coercedValue === 'number';
}
export function isDate(value) {
    try {
        new Date(value).toISOString();
    }
    catch (error) {
        return false;
    }
    return true;
}
export function isString(value) {
    return !isDate(value) && !isNumber(value);
}
export function getDataType(value) {
    if (isNumber(value)) {
        return 'number';
    }
    else if (isDate(value)) {
        return 'date';
    }
    return 'string';
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window['fns'] = {
    isDate: isDate,
    isNumber: isNumber,
    isString: isString,
    getDataType: getDataType,
};
